<template>
  <v-container id="contact-grid">
    <section class="ftco-section">
      <div class="row justify-content-center">
        <div class="col-md-12 col-lg-12">
          <div class="wrap d-md-flex">
            <div class="img" id="img-block"></div>
            <v-card class="login-wrap p-4 p-md-5">
              <div class="d-flex">
                <v-card-title class="w-100 card-title mb-2 justify-center">
                  {{ $t("login_title") }}
                </v-card-title>
              </div>
              <v-form>
                <v-text-field
                  :error-messages="emailErrors"
                  required
                  @blur="$v.email.$touch()"
                  prepend-icon="mdi-email"
                  v-model="email"
                  name="email"
                  label="Email"
                  type="email"
                ></v-text-field>
                <v-text-field
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  :error-messages="passwordErrors"
                  required
                  @blur="$v.password.$touch()"
                  v-model="password"
                  id="password"
                  prepend-icon="lock"
                  name="password"
                  :label="$t('password')"
                ></v-text-field>

                <div
                  v-if="errors['credentiel']"
                  class="text-danger text-sm-body-2"
                >
                  <span>{{ errors["credentiel"][langLocal] }}</span>
                </div>
                <div
                  v-if="errors['password']"
                  class="text-danger text-sm-body-2"
                >
                  <span>{{ errors["password"][langLocal] }}</span>
                </div>
                <div v-if="errors['email']" class="text-danger text-sm-body-2">
                  <span>{{ errors["email"][langLocal] }}</span>
                </div>

                <v-btn
                  block
                  depressed
                  style="margin-top: 18px; margin-bottom: 18px"
                  :loading="isLoading"
                  :disabled="this.$v.$invalid"
                  @click.prevent="submit"
                  type="submit"
                  color="warning"
                >
                  {{ $t("login_btn") }}</v-btn
                >
                <div class="form-group d-md-flex"></div>
              </v-form>
              <v-col class="d-flex ml-auto" cols="12" sm="12" xsm="12">
                <v-btn class="text-left mx-5" small color="warning" fab to="/"
                  ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
                <v-spacer></v-spacer><v-spacer></v-spacer><v-spacer></v-spacer
                ><v-spacer></v-spacer>
                <v-btn
                  class="text-right"
                  color="primary"
                  depressed
                  plain
                  link
                  to="/register"
                >
                  {{ $t("register_btn") }}</v-btn
                >
              </v-col>
              <v-col
                class="d-flex ml-auto text-center"
                cols="12"
                sm="12"
                xsm="12"
              >
                <v-btn
                  class="text-right"
                  color="primary"
                  depressed
                  plain
                  link
                  to="/askemail"
                >
                  {{ $t("pwdforget_btn") }}</v-btn
                >
              </v-col>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import img from "../../public/african.jpeg";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  name: "Login",
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) },
  },
  props: {
    source: String,
  },
  data() {
    return {
      show1: false,
      isLoading: false,
      img_log: img,
      email: "",
      password: "",
    };
  },
  methods: {
    submit() {
      this.isLoading = true;
      this.$v.$touch();
      const data = {
        email: this.email,
        password: this.password,
      };
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("login", data)
          .then((response) => {
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      }
    },
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);

    this.$root.$i18n.locale = this.langLocal;
    this.$store.dispatch("clear_registered");
  },
  watch: {
    authenticated(value, oldvalue) {
      if (value === true) {
        this.$store.dispatch("clear");
        this.$router.push("/demand");
      }
    },
    email() {
      this.$store.dispatch("clear");
    },
    password() {
      this.$store.dispatch("clear");
    },
  },
  beforeCreate() {
    this.$store.dispatch("clear");
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.langLocal];
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(this.getLocaleMessages["min_password"]);
      !this.$v.password.required &&
        errors.push(this.getLocaleMessages["required_password"]);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.getLocaleMessages["valid_email"]);
      !this.$v.email.required &&
        errors.push(this.getLocaleMessages["required_email"]);
      return errors;
    },
    ...mapGetters(["current_route", "errors", "authenticated", "langLocal"]),
  },
};
</script>

<style scoped>
@import "../../public/assets/css/style.css";

#contact-grid {
  width: 100%;
  min-height: 50vh;
}

#img-block {
  background-image: url("../../public/african.jpeg");
}
.mobile-position {
  margin: 10px;
}
.card-title {
  color: rgb(63, 53, 99);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #img-block {
    display: none;
  }
  .login-wrap {
    min-height: 60vh;
  }
}
</style>
